import Session from '../../global/mysession';
import { actions as meActions } from '../../resources/me';
import store from '../../store/store';
import { Theme, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import i18n from 'i18next';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

const styles = (theme: Theme) => ({
	avatar: {
		backgroundColor: theme.palette.secondary.main,
		margin: theme.spacing.unit,
	},
	form: {
		marginTop: theme.spacing.unit,
		width: '100%', // Fix IE 11 issue.
	},
	logo: {
		display: 'block',
		height: '200px',
		marginBottom: theme.spacing.unit * 3,
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: theme.spacing.unit * 8,
	},
	main: {
		display: 'block', // Fix IE 11 issue.
		marginLeft: theme.spacing.unit * 3,
		marginRight: theme.spacing.unit * 3,
		[theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
			marginLeft: 'auto',
			marginRight: 'auto',
			width: 400,
		},
		width: 'auto',
	},
	paper: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`,
	},
	submit: {
		marginTop: theme.spacing.unit * 3,
	},
});

interface IProps {
	classes: any;
	t: i18n.TFunction;
}

interface IState {
	email: string;
	password: string;
}

class Login extends Component<IProps, IState> {
	public state = {
		email: '',
		password: '',
	};

	public render() {
		const {classes, t} = this.props;

		const setEmail = (event: React.FormEvent) => this.setState({
			email: (event.target as HTMLInputElement).value,
		});
		const setPassword = (event: React.FormEvent) => this.setState({
			password: (event.target as HTMLInputElement).value,
		});

		return (
			<main className={classes.main}>
				<CssBaseline />
				<img src='images/logo.svg' className={classes.logo} alt={t('logo')} />
				<Paper className={classes.paper}>
					<form className={classes.form} onSubmit={this.handleSubmitClick}>
						<FormControl margin='normal' required={true} fullWidth={true}>
							<InputLabel htmlFor='email'>{t('email.label')}</InputLabel>
							<Input id='email' name='email' type='email' autoComplete='email' autoFocus={true} onChange={setEmail} />
						</FormControl>
						<FormControl margin='normal' required={true} fullWidth={true}>
							<InputLabel htmlFor='password'>{t('password.label')}</InputLabel>
							<Input name='password' type='password' id='password' autoComplete='current-password' onChange={setPassword} />
						</FormControl>
						<Grid container={true} justify='center'>
							<Link component={RouterLink} to='/forgotpassword'>
								{t('forgotPassword')}
							</Link>
						</Grid>
						<Button
							type='submit'
							fullWidth={true}
							variant='contained'
							color='primary'
							className={classes.submit}
						>
							{t('login')}
						</Button>
					</form>
				</Paper>
			</main>
		);
	}

	private handleSubmitClick = (event: React.FormEvent) => {
		event.preventDefault();
		event.stopPropagation();
		const {email, password} = this.state;
		store.dispatch(meActions.login(undefined, {email, password}))
			.then(({result}: any) => {
				Session.setToken(result.token);
				return true;
			})
			.catch((error: any) => {
				console.log(error);
			});
	}
}

export default withTranslation('login')(withStyles(styles as any)(Login) as any);
